import successCheckLight from '@rhg/../public/_n/animations/success_check_light.json';

export default successCheckLight;
